<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra pb-5">
    <div class="row ps-3 pt-4">
      <div class="col">
        <p> <span class="fw-bold">Bantuan Sistem</span> - Bantuan eDTS </p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila tekan butang papar.</p>
      </div>
    </div>
    <div class="row pb-3">
      <div class="col mx-5">
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">Nama Fail</th>
                <th scope="col">Tindakan</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of ListFiles.data">
                <td>{{ item.Name }}</td>
                <td>
                  <button type="button" (click)="View(item.Year)" class="btn sec-button border-0 shadow rounded-2" role="button">Papar</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

